import { Keyboard } from "lucide-react";

import { cn } from "@/lib/utils";

interface ConversationFooterProps {
  showHints?: boolean;
  className?: string;
}

/**
 * Footer component with branding and optional keyboard hints.
 */
export function ConversationFooter({
  showHints = true,
  className,
}: ConversationFooterProps) {
  return (
    <footer
      className={cn(
        "border-t border-border/30 bg-muted/30 px-4 py-3",
        className,
      )}
    >
      <div className="mx-auto flex max-w-lg items-center justify-between">
        {/* Keyboard hints */}
        {showHints && (
          <div className="flex items-center gap-1.5 text-[11px] text-muted-foreground/60">
            <Keyboard className="size-3" />
            <span>
              Press <kbd className="rounded bg-muted px-1 font-mono">Enter</kbd>{" "}
              to send
            </span>
          </div>
        )}

        {/* Branding */}
        <div className="text-[11px] text-muted-foreground/50">
          Powered by{" "}
          <a
            href="https://usemojo.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-muted-foreground/70"
          >
            usemojo.ai
          </a>
        </div>
      </div>
    </footer>
  );
}
